export const getActiveFolder = (state) => (id) => state.elements[id];
export const getRules = (state) => (id) => state.rules[id];
